import React from "react";

import { useAppSelector } from "store";
import { selectIsInsightExpanded } from "modules/customer/tools/location/locationSlice";

import { Grid, GridSize } from "@material-ui/core";

import AverageDailyFootfall from "./AverageDailyFootfall";
import AverageDailyFootfallMeasure from "./AverageDailyFootfallMeasure";
import AverageDailyFootfallText from "./AverageDailyFootfallText";
import AverageDailyFootfallTitle from "./AverageDailyFootfallTitle";
import FootfallOverTime from "./FootfallOverTime";
import FootfallOverTimeTitle from "./FootfallOverTimeTitle";
import FootfallOverTimeMeasure from "./FootfallOverTimeMeasure";
import LastTwelveMonthsTotalVisits from "./LastTwelveMonthsTotalVisits";
import LatestMonthDwellTime from "./LatestMonthDwellTime";
import LatestMonthVisits from "./LatestMonthVisits";

const FootfallOverview: React.FC = () => {
    const isInsightExpanded = useAppSelector(selectIsInsightExpanded);
    const kpiGridSize: GridSize = isInsightExpanded ? 6 : 12;
    return (
        <Grid container spacing={2}>
            <Grid item xs={kpiGridSize}>
                <LastTwelveMonthsTotalVisits />
            </Grid>
            <Grid item xs={kpiGridSize}>
                <LatestMonthVisits />
            </Grid>
            <Grid item xs={kpiGridSize}>
                <LatestMonthDwellTime />
            </Grid>
            <Grid item xs={12}>
                <FootfallOverTimeTitle />
            </Grid>
            <Grid item xs={12}>
                <FootfallOverTimeMeasure />
            </Grid>
            <Grid item xs={12}>
                <FootfallOverTime />
            </Grid>
            <Grid item xs={12}>
                <AverageDailyFootfallTitle />
            </Grid>
            <Grid item xs={12}>
                <AverageDailyFootfallMeasure />
            </Grid>
            <Grid item xs={12}>
                <AverageDailyFootfallText />
            </Grid>
            <Grid item xs={12}>
                <AverageDailyFootfall />
            </Grid>
        </Grid>
    );
};

export default FootfallOverview;
